module.exports = __webpack_public_path__ + "assets/img/lector-11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-11.png
// module id = 1956
// module chunks = 0